import { DirectiveOptions } from "vue";
import { UserModule } from '@/store/modules/user'

export const auth: DirectiveOptions = {
    bind(el, binding, vnode: any) {
        let flag: string = binding.arg ? binding.arg : "";
        let h = UserModule.buttonsAuth.includes(flag);

        if (h && typeof binding.value == 'function') {
            binding.value();
        }
    }
};
